import { RouteType } from '@/main/menu/constants';

import { UzaverkaSkladu } from './uzaverkaSkladu';
import { UzaverkaObjednavekNd } from './uzaverkaObjednavekNd';
import { UzaverkaRozpracovanost } from './uzaverkaRozpracovanost';
import { UzaverkaPokladen } from './uzaverkaPokladen';
import { NAME as name } from './constants';
import { UzaverkaUcetni } from './uzaverkaUcetni';

export const menu = {
	name,
	list: [
		{ name: 'pUzaverkaRozprac', route: UzaverkaRozpracovanost.name },
		{ name: 'pUzavPoklad', route: UzaverkaPokladen.name },
		{ name: 'pUzaverkaUcto', route: UzaverkaUcetni.name },
		{ name: 'UzaverkaSklad', route: UzaverkaSkladu.name },
		{ name: 'UzaverkaObjednavekNd', route: UzaverkaObjednavekNd.name },
		{ name: 'UzaverkaAutoPart', route: '/DMSC/autopart', routeType: RouteType.url },
	],
};
